//src/components/services/index.js
import React, { useState, useEffect } from 'react';
import ServiceTabs from './ServiceTabs';
import ServicePackages from './ServicePackages';

const ServicesContainer = ({ activeTab: initialTab = 'full', onSelectService = null }) => {
  const [activeTab, setActiveTab] = useState(initialTab);
  
  // Update local state when the prop changes
  useEffect(() => {
    setActiveTab(initialTab);
  }, [initialTab]);
  
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // If parent component provided a callback, notify it of the change
    if (onSelectService && typeof onSelectService === 'function') {
      onSelectService({ type: 'category', value: tab });
    }
  };
  
  const handleServiceSelect = (category, service, price) => {
    // If parent component provided a callback, notify it of the service selection
    if (onSelectService && typeof onSelectService === 'function') {
      onSelectService({ 
        type: 'service', 
        category: category, 
        service: service, 
        price: price 
      });
    }
  };
  
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Premium Detailing Services</h2>
          <div className="w-16 md:w-20 h-1 bg-gradient-to-r from-blue-500 to-cyan-400 mx-auto mb-4 md:mb-6"></div>
          <p className="max-w-lg md:max-w-2xl mx-auto text-gray-600 text-sm md:text-base">
            Transform your vehicle with our professional detailing services using premium products and expert techniques.
          </p>
        </div>
        
        {/* Tabs Navigation */}
        <ServiceTabs 
          activeTab={activeTab} 
          onTabChange={handleTabChange} 
        />
        
        {/* Service Packages */}
        <ServicePackages 
          activeTab={activeTab} 
          onServiceSelect={handleServiceSelect} 
        />
      </div>
    </section>
  );
};

export default ServicesContainer;